(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/cookies-check-and-info/views/third-party-cookies-check.js') >= 0) return;  svs.modules.push('/components/components/cookies-check-and-info/views/third-party-cookies-check.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_cmps=_svs.components=_svs.components||{};
_cmps.cookies_check_and_info=_cmps.cookies_check_and_info||{};
_cmps.cookies_check_and_info.templates=_cmps.cookies_check_and_info.templates||{};
svs.components.cookies_check_and_info.templates.third_party_cookies_check = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<iframe src=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.viewData : depth0)) != null ? stack1.pageUrl : stack1), depth0))
    + "\"  class=\"iframe-third-party-cookies-check\"/>";
},"useData":true});
Handlebars.partials['components-components-cookies_check_and_info-third_party_cookies_check'] = svs.components.cookies_check_and_info.templates.third_party_cookies_check;
})(svs, Handlebars);

 })(window);